import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { ImageBlock } from "../components/ImageBlock";
import { ApartmentTable } from "../components/ApartmentTable";
import { BUILDINGS } from "../data/apartments";
import { useBuildings } from "../data/ApartmentDataContext";
import { IMAGES } from "../data/images";
import { Seo } from "../components/Seo";

export default function BuildingPage({ buildingKey, route }) {
  const { t } = useLang();
  const { buildings } = useBuildings();
  const building = buildings[buildingKey] || BUILDINGS[buildingKey];

  const isMigdolas = buildingKey === "Migdolas";
  const title = isMigdolas ? t("building.migdolasTitle") : t("building.vysniaTitle");
  const sub = isMigdolas ? t("building.migdolasSub") : t("building.vysniaSub");
  const heroImg = isMigdolas ? IMAGES.migdolasHero : IMAGES.vysniaHero;

  return (
    <div data-testid="building-page" className="pt-28">
      <Seo
        title={`${title} — nauji butai | Sakurų namai`}
        description={`${title}: nauji A++ energinės klasės butai Marijampolėje, Parko g. 1D. ${sub}`}
        path={`/${route}`}
      />
      {/* Full-width cover / hero banner (same treatment for both buildings) */}
      <section
        className="relative w-full h-[45vh] min-h-[320px] md:h-[50vh] overflow-hidden"
        data-testid={`${isMigdolas ? "migdolas" : "vysnia"}-hero`}
      >
        <img
          src={heroImg}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover"
          data-testid={`${isMigdolas ? "migdolas" : "vysnia"}-hero-image`}
        />
        <div className="absolute inset-0 bg-charcoal/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/40 to-charcoal/20" />
        <div className="absolute bottom-0 left-0 right-0">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-8 md:pb-12">
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-3">{sub}</p>
            <h1 className="font-serif text-5xl sm:text-6xl font-light text-cream drop-shadow-lg">{title}</h1>
          </div>
        </div>
      </section>

      {/* Apartment table */}
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <h2 className="font-serif text-3xl font-light text-cream mb-8">{t("building.apartmentTable")}</h2>
        <ApartmentTable apartments={building.apartments} route={route} buildingKey={buildingKey} />
      </section>
    </div>
  );
}
